module.exports = "<h4>Add a Loop</h4>\n<p>Loops can allow you to repeat a sequence of other automation actions until some condition is satisfied. Use the list below\n\tto identify the condition that you would like to control the repeating of this loop.</p>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/codeitem-loop/codeitem-loop.component.html
// module id = 1513
// module chunks = 2